import { useEffect, useState } from "react";
import authService from "../services/authService";
import { UserModel } from "../models/UserModel";
import Network from "../netWork/Network";
import ApiResponse from "../netWork/ApiResponse";
import RsaBase from "../netWork/RsaBase";

let _instance: UserModel | null = null;
let isLoading: boolean = false;

export default function useUserData() {
    const [userData, setUserData] = useState<UserModel | null>(null);
    // -1: 执行中
    // 0: 登录失败
    // 1: 登录成功
    const [loginStatus, setLoginStatus] = useState<number>(-1);
    useEffect(() => {
        loadUserData();
        console.log('我调用了')
    }, []);
    const loadUserData = async () => {
        const userData = await authService.loadCurrentUser();
        if (userData) {
            _instance = userData;
            setUserData(_instance);
            setLoginStatus(1);
            console.log(userData,'userData');
            console.log('登录成功')
        } else {
            console.log('userData',userData);
            setUserData(null);
            setLoginStatus(0);
            console.log('登录失败')
        }
    }

    const chnagePassword = async (oldPassword: string, newPassword: string) => {
        try {
            const enOldPassword = RsaBase.encryptData(oldPassword);
            const enNewPassword = RsaBase.encryptData(newPassword);
            const response = await Network.post<ApiResponse<any>>("/user/password/update", {
                old_password: enOldPassword,
                new_password: enNewPassword
            });
            if (response.code === 200) {
                return true;
            }
            return false;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    const updateUserInfo = async (userInfo: Record<string, any>): Promise<boolean> => {
        try {
            const response = await Network.post<ApiResponse<any>>("/user/update", userInfo);
            if (response.code === 200) {
                loadUserData();
                return true;
            }
            return false;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    const sendEmailCode = async (email: string): Promise<boolean> => {
        try {
            const response = await Network.post<ApiResponse<any>>("/email/send-email-code", {
                email: email
            });
            if (response.code === 200) {
                return true;
            }
            return false;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    const updateEmail = async (email: string, code: string): Promise<boolean> => {
        try {
            const response = await Network.post<ApiResponse<any>>("/user/email/update", {
                email: email,
                code: code
            });
            if (response.code === 200) {
                loadUserData();
                return true;
            }
            return false;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    const sendPhoneCode = async (phone: string, zone: string): Promise<boolean> => {
        try {
            const response = await Network.post<ApiResponse<any>>("/user/phone/send-code", {
                phone: phone,
                country_code: zone
            });
            if (response.code === 200) {
                return true;
            }
            return false;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    const updatePhone = async (phone: string, zone: string, code: string): Promise<boolean> => {
        try {
            const response = await Network.post<ApiResponse<any>>("/user/mobile/update", {
                mobile: phone,
                zone: zone,
                sms_code: code
            });
            if (response.code === 200) {
                loadUserData();
                return true;
            }
            return false;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    return {
        userData,
        loginStatus,
        chnagePassword,
        updateUserInfo,
        sendEmailCode,
        updateEmail,
        sendPhoneCode,
        updatePhone
    }
}